/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Constants for Widget Personal Account
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.0.1
 */

import { EAccountType } from '../../../../../PageAuth/constants/authConstants';
import { IWidgetPersonalAccountReducer } from '../types/widgetPersonalAccountType';

export const widgetPersonalAccountInitialState: IWidgetPersonalAccountReducer = {
    data: {
        accountNumber: '',
        balanceDate: '',
        cashbackAmount: 0,
        currentBalance: 0,
        isCashbackAvailable: false,
        outflowType: EAccountType.CREDIT,
        urlHowToGetCashback: '',
        urlHowToSpentCashback: '',
    },
    error: '',
    isLoading: false,
};
